var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8361 4.05829C15.3562 4.24404 15.6273 4.81626 15.4415 5.33636L10.4415 19.3364C10.2558 19.8565 9.68356 20.1275 9.16345 19.9418C8.64334 19.756 8.37229 19.1838 8.55804 18.6637L13.558 4.66369C13.7438 4.14358 14.316 3.87253 14.8361 4.05829Z",
    fill: "#3B445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70711 6.29289C7.09763 6.68342 7.09763 7.31658 6.70711 7.70711L2.41421 12L6.70711 16.2929C7.09763 16.6834 7.09763 17.3166 6.70711 17.7071C6.31658 18.0976 5.68342 18.0976 5.29289 17.7071L0.292893 12.7071C-0.0976311 12.3166 -0.0976311 11.6834 0.292893 11.2929L5.29289 6.29289C5.68342 5.90237 6.31658 5.90237 6.70711 6.29289Z",
    fill: "#3B445A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2929 7.70711C16.9024 7.31658 16.9024 6.68342 17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289L23.7071 11.2929C24.0976 11.6834 24.0976 12.3166 23.7071 12.7071L18.7071 17.7071C18.3166 18.0976 17.6834 18.0976 17.2929 17.7071C16.9024 17.3166 16.9024 16.6834 17.2929 16.2929L21.5858 12L17.2929 7.70711Z",
    fill: "#3B445A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.27654a7639622fcdf8f7a1640133df7b.svg";
export { ForwardRef as ReactComponent };